<template>
  <label class="switch" :for="id">
    <input :id="id" type="checkbox" :checked="checked" :aria-label="id" @change="onChange" />
    <span class="slider round"></span>
  </label>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    checked: false,
    id: {
      type: String,
      required: true,
    },
  },

  emits: ['onChange'],

  methods: {
    onChange(event) {
      this.$emit('onChange', event)
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/tokens';
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 38px;
  height: 20px;
  pointer-events: auto;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $token-color-sidebar-hover;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  outline: 2px solid white;
}

.slider::before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #3397f1;
}

input:focus + .slider {
  box-shadow: 0 0 1px #3397f1;
}

input:checked + .slider::before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round::before {
  border-radius: 50%;
}
</style>
